import { EmployeeModel } from '@shared/models';

export class PhotoDocumentBasicModel {
  id:                        number;
  created_at:                string;
  read_at:                   string;

  subject:                   string;
  subject_corrected:         string;
}

export class PhotoDocumentSimplifiedModel extends PhotoDocumentBasicModel {
  state:                     PhotoDocumentStates;
  external_employee:         EmployeeModel;

  archived_by_system_at:     string;
  released_to_archive_at:    string;
  released_to_zvoove_status: string;
  released_to_zvoove_at:     string;
}

export class PhotoDocumentModel extends PhotoDocumentSimplifiedModel {
  personal_number:                      number;

  released_to_archive_by:               EmployeeModel;
  released_to_zvoove_by:                EmployeeModel;

  submit_to_zvoove:                     boolean;

  message_external_employee:            string;
  comment_internal_employee:            string;

  attachment_url:                       string;
  attachment_rotation_angle:            number;
  additional_attachment_url:            string;
  additional_attachment_rotation_angle: number;

  days_before_auto_archive:             number;
}

export enum PhotoDocumentStates {
  unreleased = "unreleased",
  archived   = "released_to_archive",
  zvooved    = "released_to_zvoove",
  deleted    = "archived_by_system",
};
